export const defaultTemplate = {
	REQUEST: 'DEFAULT_TEMPLATE_REQUEST',
	RECEIVE: 'DEFAULT_TEMPLATE_RECEIVE',
	REORDER: 'WIDGETS_REORDER'

};
export const widgetAction = {
	ADD: 'WIDGET_ADD',
	INITSET:'WIDGET_INITSET',
	OUT:'LOG_OUT',
	REMOVE_RESULT_WIDGET: 'RESULT_WIDGET_REMOVE',
	REMOVE_DASHBOARD_WIDGET: 'DASHBOARD_WIDGET_REMOVE',
	RESIZE_RESULTPAGE: 'WIDGET_RESIZE_IN_RESULT_PAGE',
	RESIZEWITHFAKER_RESULTPAGE: 'WIDGET_RESIZE_WITH_FAKE_WIDGET_IN_RESULT_PAGE',
	RESIZE_DASHBOARD: 'WIDGET_RESIZE_IN_DASHBOARD',
	RESIZEWITHFAKER_DASHBOARD: 'WIDGET_RESIZE_WITH_FAKE_WIDGET_IN_DASHBOARD',
	CHANGELAYOUT_DASHBOARD: 'CHANGE_DASHBOARD_PAGE_LAYOUT',
	CHANGELAYOUT_RESULTPAGE: 'CHANGE_RESULT_PAGE_LAYOUT',
	DEMO: 'DEMO'
};



// WEBPACK FOOTER //
// ./src/constants/widget.constants.js